var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgA3ExternalSpotOff(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 7v62h62V7H7zm58 58H11V11h20v23.56a2.216 2.216 0 000 .44v.13c.03.096.067.19.11.28l.07.14.15.22c.036.04.07.084.1.13l.21.19.11.09c.094.066.195.123.3.17h.07c.134.06.275.103.42.13h.43c.2.003.4-.027.59-.09a1.76 1.76 0 00.56-.29 2.15 2.15 0 00.88-1.62V11h30v54zM50.28 36h8.5L36 59.92v-8.25L18 35.16l9-8.89v8.29a6 6 0 1012-.08V26.1L50.28 36z",
    fill: "currentColor"
  })));
}
export default __webpack_public_path__ + "static/media/A3_External_spot_off.081546c8.svg";
export { SvgA3ExternalSpotOff as ReactComponent };